export default "__VITE_ASSET__CnoGiwLP__"